import { Injectable } from '@angular/core';
import {
  OrderCheckoutModel, OrderPayloadModel,
  OrderTokenModel, OrderTokenPayloadModel,
} from '@libs/shop/models';
import { ConnectorService } from '@libs/shared/services';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CheckoutRepositoryService {
  public constructor(
    private readonly connector: ConnectorService,
  ) {
  }

  public placeOrder(payload: OrderPayloadModel): Observable<OrderCheckoutModel> {
    return this.connector.connect('shop', 'orderCheckout', { payload });
  }

  public getOrderToken(cartId: string): Observable<OrderTokenModel> {
    return this.connector.connect('shop', 'orderToken', {
      payload: {
        type: 'lekkerland-order-token',
        id: '',
        cartId: cartId,
      } satisfies OrderTokenPayloadModel,
    });
  }
}
